// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\r\n/* .el-table__fixed,\r\n.el-table__fixed-right {\r\n  height: calc(100% - 11px) !important;\r\n  -moz-height: calc(100% - 17px) !important;\r\n  -ms-height: calc(100% - 17px) !important;\r\n  -o-height: calc(100% - 17px) !important;\r\n}\r\n\r\n.el-table__fixed:before {\r\n  content: '';\r\n  height: 0 !important;\r\n} */\r\n", ""]);
// Exports
module.exports = exports;
